import { NextPage } from 'next'
import styles from '../../_artistPage.module.scss'
import ArtistLayout from '../../components/ArtistLayout'
import {
  staticPath,
  staticProps
} from '../../../../../utils/createApolloClient'
import SongsList from '../../../../songs/Components/SongsList'
import {
  ARTISTS_LIST_QUERY,
  ARTIST_DETAILS_QUERY,
  SONGS_LIST_QUERY
} from '../../../../../gql'
import { initalFiltersState } from '../../songs'
import { Artist, Song } from '../../../../../__generated__/graphql'

const AritstAlbumsPage: NextPage<{ artist: Artist; albumSongs: Song[] }> = ({
  artist,
  albumSongs
}) => {
  if (!artist) return <></>

  return (
    <ArtistLayout artist={artist}>
      <div className={styles.songsListHolder}>
        <SongsList songs={albumSongs} isFlat={true} inList={true} />
      </div>
    </ArtistLayout>
  )
}

export const getStaticPaths = staticPath({
  additionalPaths: async ({ client }) => {
    const { data } = await client.query({
      query: ARTISTS_LIST_QUERY
    })

    const paths = data.artists
      .map((artist) => {
        return artist.albums.map((album) => ({
          params: { id: artist.id.toString(), album_id: album.id.toString() }
        }))
      })
      .flat()

    return {
      paths,
      fallback: true
    }
  }
})
export const getStaticProps = staticProps({
  additionalProps: async ({ client, ctx }) => {
    const {
      data: { artist }
    } = await client.query({
      query: ARTIST_DETAILS_QUERY,
      variables: { id: Number(ctx.params.id) }
    })
    const {
      data: { songs: albumSongs }
    } = await client.query({
      query: SONGS_LIST_QUERY,
      variables: {
        albumIds: [Number(ctx.params.album_id)],
        ...initalFiltersState
      }
    })

    return {
      artist,
      albumSongs
    }
  }
})

export default AritstAlbumsPage
